export default {
      id: "walk_run_intervals-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#walk_run_intervals",
      toString: function () {
        return this.url;
      }
    }